import React, { Component } from 'react';
import {
    avgDmarcBlockRateSelector,
    dmarcEffectivenessIsLoadedSelector,
} from '../../selectors/dmarc-effectiveness-selectors';
import {
    formattedEndDateSelector,
    formattedStartDateSelector
} from '../../selectors/reports-selectors';

import ProgressBulletGroup from '../../components/progress-bullet-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDifferenceInRange } from '../../../utils/report-utils';

export class DmarcEffectivenessProgressBulletsContainer extends Component{
    buildBulletMap = () => {
        const { startDate, endDate, rate } = this.props;
        const numberOfDays = getDifferenceInRange( startDate, endDate );

        return [
            { text: `Our average block rate over ${numberOfDays} days (between ${startDate} and ${endDate}) was ${rate}%.` },
            { text: 'Implementing blocking policies typically results in 99% of unauthorized email getting blocked.' }
        ];
    }

    render(){
        const { isLoaded } = this.props;

        return (
            isLoaded &&
            <ProgressBulletGroup bullets={this.buildBulletMap()} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        endDate: formattedEndDateSelector( state ),
        isLoaded: dmarcEffectivenessIsLoadedSelector( state ),
        rate: avgDmarcBlockRateSelector( state ),
        startDate: formattedStartDateSelector( state ),
    };
};

DmarcEffectivenessProgressBulletsContainer.propTypes = {
    endDate: PropTypes.string.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    rate: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps )( DmarcEffectivenessProgressBulletsContainer );
